import React from 'react';
import { Shuffle, FolderX, Layers } from 'lucide-react';

const CARDS = [
  {
    icon: Shuffle,
    title: 'Client A doc, Client B folder',
    body:
      "You're three weeks into a grant cycle and a draft narrative for Credit Union A lands in Credit Union B's folder because both files were named 'final_v3.docx'. You catch it before you send it. Probably. You hope.",
  },
  {
    icon: FolderX,
    title: 'Blended personal and client Downloads',
    body:
      "Tax docs for your holding company, a contract for a consulting engagement, a retail shop's lease renewal, and the kids' school PDFs are all in the same Downloads folder. Filing them takes longer than reading them.",
  },
  {
    icon: Layers,
    title: 'Multi-business attribution',
    body:
      "When you run three businesses, the same email account, the same Dropbox, and the same Mac handle all three. At year-end the accountant asks which expenses belong to which entity. The honest answer is 'I'll need a week to figure that out.'",
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          The Filing Problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Three patterns we hear from solo consultants and multi-venture founders.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div
              key={i}
              className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6"
            >
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PainPoints;
